import { ReactNode } from 'react';

import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

type ButtonSpinnerTint = 'dark' | 'light';

const ButtonSpinner = ({
	isLoading,
	children,
	tint,
}: {
	isLoading: boolean;
	children: ReactNode;
	tint?: ButtonSpinnerTint;
}) => {
	return (
		<>
			{isLoading ? (
				<Spinner
					verticalMargin={0}
					size="18px"
					isLoading
					color={tint === 'light' ? 'white' : 'slateBlue'}
				/>
			) : (
				children
			)}
		</>
	);
};

export default ButtonSpinner;
